import { GET_INTERNATIONAL_STATE_REQUEST, GET_INTERNATIONAL_STATE_SUCCESS, GET_INTERNATIONAL_STATE_ERROR } from "../actions/types"

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_INTERNATIONAL_STATE_REQUEST:
            return {
                loading: true,
            };
        case GET_INTERNATIONAL_STATE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_INTERNATIONAL_STATE_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}